import { Fragment } from "react";
import { useLocation } from "react-router-dom";
import { type ILandscapeSection } from "src/generator/LandscapeOrientation/landscape.types";
import type { ICol } from "src/interfaces";

import SectionTitle from "../SectionTitle";
import LandscapeRow from "./LandscapeRow";

interface Props {
  section: ILandscapeSection;
  title?: string;
  subtitle?: string;
  applyHistory?: boolean;
  historyRows?: Array<ICol[][]>;
  sectionIndex?: number;
  collapseable?: boolean;
  collapsed?: boolean;
}
const LandscapeSection = ({
  section,
  subtitle,
  title,
  applyHistory,
  sectionIndex,
  collapseable,
  collapsed,
}: Props) => {
  const location = useLocation();
  const isInLogbookEntry =
    location.pathname.includes("/logbook/") &&
    !location.pathname.includes("/history");

  return (
    <div>
      <SectionTitle
        title={title}
        subtitle={subtitle}
        sectionIndex={sectionIndex}
        collapseable={collapseable}
        collapsed={collapsed}
      />
      {(!isInLogbookEntry || !collapseable || !collapsed) && (
        <table
          className="landscape-table"
          style={{
            marginBottom: "20px",
            borderSpacing: 0,
            borderCollapse: "collapse",
            fontSize: "0.875rem",
          }}>
          {section.rows.map((row, index: number) => (
            <Fragment key={`section-row-${index}`}>
              {/* history commented out for now! */}
              {/* {hrows[index] && */}
              {/*  Array.isArray(hrows[index]) && */}
              {/*  hrows?.[index].map((hr: any, index: number) => ( */}
              {/*    <LandscapeRow key={`history-row-${index}`} row={hr} history /> */}
              {/*  ))} */}
              <LandscapeRow
                key={`current-row-${index}`}
                row={row}
                history={applyHistory}
              />
            </Fragment>
          ))}
        </table>
      )}
    </div>
  );
};
export default LandscapeSection;
